import update from "immutability-helper";

import * as commands from "./commands";
import * as queries from "./queries";
import * as actions from "./actions";
import { dateTimeFormater } from "../../../utilities/formaters";

let initialState = {};

const loanNotes = (state = initialState, action = { type: "" }) => {
  switch (action.type) {
    case commands.CREATE_LOAN_NOTE_REQUEST:
      return update(state, {
        [action.dataSent.LoanId]: {
          sending: { $set: true },
          error: { $set: "" },
        },
      });

    case commands.CREATE_LOAN_NOTE_SUCCESS:
      return update(state, {
        [action.dataSent.LoanId]: {
          sending: { $set: false },
          sent: { $set: true },
          data: { $push: newPost(action.dataSent) },
        },
      });

    case commands.CREATE_LOAN_NOTE_ERROR:
      return update(state, {
        [action.dataSent.LoanId]: {
          sending: { $set: false },
          sent: { $set: false },
          error: { $set: "error creating note" },
        },
      });

    case actions.CREATE_LOAN_SENT_CONFIRM:
      return update(state, { [action.loanId]: { sent: { $set: false } } });

    case queries.LOAN_NOTE_GET_REQUEST:
      if (state[action.additionalData])
        return update(state, {
          [action.additionalData]: {
            fetching: { $set: true },
            error: { $set: "" },
          },
        });
      else return { [action.additionalData]: { fetching: true } };

    case queries.LOAN_NOTE_GET_SUCCESS:
      return update(state, {
        [action.additionalData]: {
          fetching: { $set: false },
          fetched: { $set: true },
          data: { $set: action.response },
        },
      });

    case queries.LOAN_NOTE_GET_ERROR:
      return update(state, {
        [action.additionalData]: {
          fetching: { $set: false },
          error: { $set: "error loading notes" },
        },
      });

    default:
      return state;
  }
};

export default loanNotes;

function newPost(post) {
  return [
    {
      Id: dateTimeFormater(new Date()),
      Text: post.Text,
      Author: "You",
      Created: new Date(),
    },
  ];
}
